import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Redirects to nextRoute when permission === false
export const usePermissionRedirect = (
  permission?: boolean,
  nextRoute?: string
) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (permission === false && nextRoute) {
      navigate(nextRoute);
    }
  }, [permission, nextRoute, navigate]);
};

export default usePermissionRedirect;
